/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.conf.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/


import '@quasar/extras/material-icons/material-icons.css'
// We load Quasar stylesheet file
import 'quasar/dist/quasar.sass'
import 'src/css/app.scss'
import 'src/css/components-ui.css'
import 'src/css/global.scss'
import '../public/css/editor-ctx.css';
import 'izitoast/dist/css/iziToast.min.css'


import Vue from 'vue'
import createApp from './app.js'
// import qboot_Bootcompositionapi from 'boot/composition-api'
// import qboot_Booti18n from 'boot/i18n'
import qboot_Bootaxios from 'boot/axios'
import qboot_Bootimdglobal from 'boot/imd-global'


Vue.config.devtools = true
Vue.config.productionTip = false

// console.info('[Quasar] Running SPA.')
const publicPath = `/`

async function start () {
  const { app, router } = await createApp()

  let hasRedirected = false
  const redirect = url => {
    hasRedirected = true
    const normalized = Object(url) === url
      ? router.resolve(url).route.fullPath
      : url

    window.location.href = normalized
  }

  const urlPath = window.location.href.replace(window.location.origin, '')
  // const bootFiles = [qboot_Bootcompositionapi,qboot_Booti18n,qboot_Bootaxios,qboot_Bootimdglobal]
  const bootFiles = [qboot_Bootaxios,qboot_Bootimdglobal]

  for (let i = 0; hasRedirected === false && i < bootFiles.length; i++) {
    if (typeof bootFiles[i] !== 'function') {
      continue
    }

    try {
      await bootFiles[i]({
        app,
        router,
        Vue,
        ssrContext: null,
        redirect,
        urlPath,
        publicPath
      })
    }
    catch (err) {
      if (err && err.url) {
        window.location.href = err.url
        return
      }

      console.error('[Quasar] boot error:', err)
      return
    }
  }

  if (hasRedirected === true) {
    return
  }

  // console.log('*** 호출됨 : fe/_quasar/client-entry.js')
  new Vue(app)
}
start()
